"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var variables_1 = require("../../../style/variables");
var icons_1 = require("../../../icons");
var Tooltip_1 = __importDefault(require("../../Tooltip"));
var styles = {
    button: react_1.css({
        position: 'absolute',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        height: '28px',
        width: '28px',
        borderRadius: '50%',
        border: "1px solid var(" + variables_1.RootColor.Gray.LIGHT_3 + ")",
        backgroundColor: "var(" + variables_1.RootColor.White + ")",
        zIndex: 10,
        transition: 'all 0.3s ease',
        top: '28px',
        ':hover': {
            background: "var(" + variables_1.ThemeColor.Primary.DEFAULT + ")",
            color: "var(" + variables_1.RootColor.White + ")",
        },
        ':focus-visible:enabled, :active:enabled': {
            background: "var(" + variables_1.ThemeColor.Primary.DARK_1 + ")",
            color: "var(" + variables_1.RootColor.White + ")",
            boxShadow: "var(" + variables_1.Focus.PRIMARY_LIGHT + ")",
            outline: 'none',
        },
    }),
};
var SidePanelCollapseButton = function (_a) {
    var _b;
    var onClick = _a.onClick, expanded = _a.expanded, _c = _a.position, position = _c === void 0 ? 'left' : _c;
    return (react_1.jsx(Tooltip_1.default, { placement: position === 'left' ? 'right' : 'left', overlay: expanded ? 'Collapse' : 'Expand' },
        react_1.jsx("button", { onClick: function () { return onClick(); }, css: [
                styles.button,
                position === 'left' ? undefined : { transform: 'rotateY(180deg)' },
                (_b = {}, _b[position === 'left' ? 'right' : 'left'] = -14, _b),
            ] }, expanded ? react_1.jsx(icons_1.FoldLeft, { size: 16 }) : react_1.jsx(icons_1.FoldRight, { size: 16 }))));
};
exports.default = SidePanelCollapseButton;
